// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"closeBtn-module--closeBtn--1gQrW","texture":"closeBtn-module--texture--32lt7","hoverCircle":"closeBtn-module--hoverCircle--1k01C","icon":"closeBtn-module--icon--3op-b"};